module.exports = __webpack_public_path__ + "static/media/practice-shade2.55a2cc88.svg";